import { TipoIstanzaFascicoloVO } from "./tipo-istanza-fascicoloVO";
import { ElementoVicinoVO } from "./elemento-vicinoVO";

export class RiferimentiPosizioneVO {
    idPadre: string;
    oggettoPadre: string;
    tipoFascicoloPadre: TipoIstanzaFascicoloVO;
    elementoSuperiore: ElementoVicinoVO = new ElementoVicinoVO();
    elementoInferiore: ElementoVicinoVO = new ElementoVicinoVO();
    posizione: number;

}